import { formatNumber } from "../../../utils/formatNumber";
import "./MoneyCell.scss";
const MoneyCell = ({ displayName, data, extraData }: any) => {
  return (
    <div className="money-cell-container">
      <span>{displayName}</span>
      <div>
        {data ? (
          <>
            <span>$</span> {formatNumber(data)}
          </>
        ) : (
          <>-</>
        )}
      </div>
    </div>
  );
};

export { MoneyCell };
